import React from "react";
import CheckboxListItem from "./CheckboxListItem";
import ControlFeedback from "./ControlFeedback";
import { CheckboxListControlProps } from "./Types";

const CheckboxListControl: React.FC<CheckboxListControlProps> = ({ name, value, disabled, width, validationResults, onChange, onBlur, layout, options }) => {

    let isValid = validationResults && validationResults.length > 0 ? false : true;

    if (width === undefined)
        width = '100%';

    if (!options)
        return <></>;

    function onControlChange(optionValue: any, checked: boolean) {
        //console.log('checklistcontrol onChange', optionValue, checked)
        //console.log('value', value)
        if (Array.isArray(value)) {
            if (checked) {
                value.push(optionValue);
                onChange([...value]);
            }
            else {
                let filteredValues = value.filter((v) => v != optionValue)
                //console.log('filtered', filteredValues)
                onChange([...filteredValues]);
            }
        }
        else {
            if (checked)
                onChange([value])
            else
                onChange([])
        }
    }

    //console.log('value', value)
    //console.log('options', options)

    var checkboxes = options.map((option, index: number) => {
        let checked = false
        if (Array.isArray(value) && value.filter((v) => v == option.value).length > 0)
            checked = true
        
        return <CheckboxListItem name={`${name}_${index}`} checked={checked} disabled={disabled} onChange={onControlChange} onBlur={onBlur} validationResults={validationResults} layout={layout} option={option} key={`${name}_${index}`} />
    })

    return (
        <div style={{ width: width }}>
            {checkboxes}
            <ControlFeedback isValid={isValid} validationResults={validationResults}></ControlFeedback>
        </div>
    );
}
export default CheckboxListControl;